// PrivateRoute.js
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUsers } from '../context/usersContext';
import { isSessionOver } from '../services/authStorage';

const PrivateRoute = () => {
  const { userInfo, logout } = useUsers(); // Pega o logout do contexto

  const accessToken = localStorage.getItem('accessToken');
  const isLogged = accessToken && userInfo;

  useEffect(() => {
    // Sem token, ou a 5 min (ou menos) de o token vencer sem ter como renovar: encerra a sessão
    // (com aviso de sessão expirada só se havia token).
    if (isSessionOver()) logout(accessToken ? { reason: 'expired' } : undefined);
  }, [accessToken, logout]);

  return isLogged ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
